export default __webpack_public_path__ + "static/media/100_71439.3794ab04.jpg";